import { TitleSearchFeeSettings } from '@models/titleSearch';
import { TeranetDocket } from '@models/matter';
import { Selector } from '@ngxs/store';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { UserProfileState } from '@state/user-profile';

export interface SummaryDocketComponentState {
	saleId: string;
	matterNumber: string;
	matterName: string;
	createdAt: number;
	hst: number;
	titleSearchFeeSettings: TitleSearchFeeSettings;
	docket: TeranetDocket;
	teranetUsername: string;
	teranetPassword: string;
	teranetAccount: string;
}

export class SummaryDocketComponentSelector {
	@Selector([
		SelectedMatter.id,
		SelectedMatter.matterNumber,
		SelectedMatter.matterName,
		SelectedMatter.createdAt,
		SelectedMatter.matterHST,
		SelectedMatter.getTitleSearchFeeSettings,
		SelectedMatter.teranetDocket,
		UserProfileState.getTeranetUsername,
		UserProfileState.getTeranetPassword,
		UserProfileState.getTeranetAccountName,
	])
	public static getSummaryDocketComponentState(
		saleId: string,
		matterNumber: string,
		matterName: string,
		createdAt: number,
		hst: number,
		titleSearchFeeSettings: TitleSearchFeeSettings,
		docket: TeranetDocket,
		teranetUsername: string,
		teranetPassword: string,
		teranetAccount: string,
	): SummaryDocketComponentState {
		return {
			saleId,
			matterNumber,
			matterName,
			createdAt,
			hst,
			titleSearchFeeSettings,
			docket,
			teranetUsername,
			teranetPassword,
			teranetAccount,
		};
	}
}
